import React, { createContext, useContext, useState, useEffect } from "react";
import {StockServices} from '../services/stockServices';
import {warehouseService} from '../services/warehouseService';
import { saleServices } from "../services/saleServices";
import { purchaseorderservices } from "../services/purchaseorderService";
import { CalculationServices } from "../services/calculationsServices";
import { settingservices } from "../services/settingServices";
import { data } from "react-router";



// Create Context
const StockContext = createContext();

// Custom hook for easy access
export const useStock = () => useContext(StockContext);

// Provider component
export const StockProvider = ({ children }) => {
  const [stockItems, setStockItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [instock, setStockalert] = useState(false);
  const [refresh, setStockRefresh] = useState('');
  const [ordergraphsdata, setOrdergraphs] = useState('0');
  const [salesdata, setTotalsales] = useState('0');
  const [approvedpo, setApprovedpo] = useState({'approved':'0','nonapproved':'0'});
  const [isshopifyconnected,setShopifyConnection] = useState(false);
  const [shopifystocks,setShopifystocks] = useState({loading:false,data:[],ordersloading:false});
  const [settingsdata,setSettings] = useState([]);
  const [warehouses,setWarehouses] = useState({loading:false,data:[]});
  const [allwarehouses,setAllWarehouses] = useState({loading:false,data:[]});

  // Fetch stock data (example from API)
  const fetchStock = async () => {
    try {
      setLoading(true);
       const response = await StockServices.getStockreports('outofstock','1','5');
      //  console.log(response.data,'context data'); 
       if(response.status == 200){
           setStockItems(response.data.data);
           if(response.data.data.length > 0){
                setStockalert(true);
           }
       }else{
           setStockItems([]);
           setStockalert(false);
       }
    //   const response = await fetch("http://10.36.80.126:8000/api/get-stock");
    //   const data = await response.json();
    
    } catch (error) {
    //   console.error("Error fetching stock:", error);
    } finally {
    //   setLoading(false);
    }
  };

  const ordergraphs = async () =>{
     let response = await saleServices.ordergraphs();
     if(response?.status == 200){
        //  console.log(response.data.data,'response orer graphs data');
         setOrdergraphs(response?.data?.data); 
         setTotalsales(response?.data?.total_sales);
     }
  } 

  // Update stock (local + API)
  const updateStock = async (refreshdata) => {
     setStockRefresh(refreshdata);
  };

  useEffect(() => {
    fetchStock();
    ordergraphs();
    getpurchaseorderAnalytics();
    isShopifyConnected();
    getsettingsData();
  }, []);

  useEffect(()=>{
    fetchStock(); 
    ordergraphs();
  },[refresh])


  async function getpurchaseorderAnalytics(){
     let response = await CalculationServices.getCalculations();  
     if(response?.status == 200){
         console.log(response,'calculations data');
     }  
  }

  async function isShopifyConnected(){
     let response = await CalculationServices.getshopifyconnection();  
     if(response?.status == 200){
         setShopifyConnection(true);
     }else{
         setShopifyConnection(false); 
     }
  }

  async function getShopifyProducts(){
     setShopifystocks({loading:true,data:[]});
     let dataobj = await StockServices.getShopifyProducts(); 
     console.log(dataobj,'data object');  
     if(dataobj?.status == 200){
          // setShopifystocks(dataobj.data.data);
        setShopifystocks({loading:false,data:dataobj.data.data});
     }else{
        setShopifystocks({loading:false,data:[]});
     }
  }

  async function getShopifyorders(){
     setShopifystocks({ordersloading:true});
     let dataobj = await StockServices.getShopifyorders(); 
     console.log(dataobj,'data object');  
     if(dataobj?.status == 200){
          // setShopifystocks(dataobj.data.data);
        setShopifystocks({ordersloading:false});
     }else{
        alert(dataobj.data.message);
        setShopifystocks({ordersloading:false});
     }
  }

  async function getShopifyLocationsviaAdminapi(){
     let dataobj = await StockServices.getShopifyLocationsviaAdminapi(); 
    //  console.log(dataobj,'data object');  
     setWarehouses({loading:true,data:dataobj.data.data});
     if(dataobj?.status == 200){
          // setShopifystocks(dataobj.data.data);
        setWarehouses({loading:false,data:dataobj.data.data});
     }else{
        // alert(dataobj.data.message);
        setWarehouses({loading:false,data:[]});
     }
  }

  async function getsettingsData(){
    let response = await settingservices.getsettingsData();
    if(response?.status == 200){
        //  console.log(response,'default currency module');
         setSettings(response.data.data);
    }else{
         setSettings([]);
    }
  }

 function getSettingValue(key) {
   return settingsdata.find(item => item.name === key)?.value || 'USD';
 }

 async function getShopifyactualProducts(){
     let dataobj = await StockServices.getShopifyProductsviaAdminapi();
     if(dataobj?.status == 200){
        //  console.log(dataobj,'data object');
     }else{
        // alert(dataobj.data.message);
     }
 }

 async function getallwarehouses(){
     setAllWarehouses({loading:true,data:[]});
     let dataobj = await warehouseService.getallwarehouses();
       if(dataobj?.status == 200){
            console.log(dataobj.data.data,'data object');
            setAllWarehouses({loading:false,data:dataobj.data.data});
         }else{
            setAllWarehouses({loading:false,data:[]});
            // alert(dataobj.data.message);
         }
   }

  return (
    <StockContext.Provider
      value={{
        stockItems,
        loading,
        fetchStock,
        updateStock,
        instock,
        ordergraphsdata,
        salesdata,
        isshopifyconnected,
        getShopifyProducts,
        shopifystocks,
        getShopifyorders,
        settingsdata,
        getSettingValue,
        getShopifyLocationsviaAdminapi,
        warehouses,
        getShopifyactualProducts,
        getallwarehouses,
        allwarehouses,
      }}
    >
      {children}
    </StockContext.Provider>
  );
};
